<template>
  <div>
    <div class="domain-container">
      <!-- <div v-if="domain"
           style="background-color: white;border: .05rem solid #ced9e0;padding: 1rem;padding-bottom: 1.5rem;">
        <div style="margin: .5rem;border-bottom: .05rem solid #ced9e0;padding: 1rem;padding-left: 0;padding-top: 0;">
          选择您将配套学习的省/市财税政策：</div>
        <div
          style="display: flex;flex-direction: row; flex-wrap: wrap;padding-left: 1.5rem;padding-right: 1.5rem;padding-left: .5rem;">

          <div v-for="(d,index) of domain" :key="index" @click="chose(d)"
               style="display: flex;margin: .5rem;margin-left: 0;margin-right: 0;">
            <div style="height: 16px; font-size: 16px;line-height: 16px;display: inline-block;">
              <button class="chose-domain">{{ d.name }}
              </button>
            </div>
          </div>
        </div>
      </div> -->
      <div style="height: 100%;">
        <div class="main-content" >
          <img class="bg-img" :src="`${assetsUrl}imgs/course/agent-practice.jpg`">
          <h1 style="z-index: 99">APOIT标准 会计代账实习基地</h1>
          <a class="border-white enter-btn" @click="openWindow()" >
            <span class="btn-left">Learn More
              <i class="anticon anticon-arrow-right"></i>
            </span>
            <span class="btn-right" >进入学习</span>
          </a>
        </div>
      </div>

    </div>
    <div id="noClasses" v-if="!(domain || (domainData && domainData.courseId && nextUrl))"
         style="width: 100%;height: 100%;position: relative;display:none">
      <div style="height: 10rem;width:10rem;position: absolute;  left: 0;  right: 0; margin: auto; top: 0;  bottom: 0;">
        <img style="width:10rem;" :src="`${assetsUrl}imgs/course/staleDated.png`">
        <span class="error-mess">{{ errorMess }}</span>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'Agent',
  components: {
  },
  data() {
    return {
        assetsUrl: 'https://static.51lss.com/o2ostu/assets/',
        user: {},
        domain: [],
        domainData: [],
        hytype: 3,
        nextUrl: ''
    }
  },
   props: {
    planclassesId: {
      type: String,
      required: false,
      default: ''
    },
    classesId: {
      type: String,
      required: false,
      default: ''
    },
    data: {
      type: Object,
      required: false,
      default: null
    },
  },
  created() {
    this.domain = this.data.domain
    this.domainData = this.data.domainData
    this.nextUrl = this.data.classesUrls[0].url
  },
  methods: {
    openWindow() {
        window.open(this.nextUrl)
    }
  },
}
</script>
<style scoped lang="less">
.border-white{
    border: 1px solid #ffffff;
}
.domain-container{
    position: relative;
    width: 100%;
    height: 100%;
  }
.chose-domain{
    background-color: white;
    border: white .05rem solid;
    padding: .3rem;
    padding-right: .5rem;
    padding-left: .5rem;
    border-radius: .02rem;
    font-size: .7rem;
  }
  .chose-domain:hover {
    background-color: #00abff  ;
    color: white ;
  }
.main-content{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    width: 100%;
    position: relative;
    .enter-btn{
        margin: 30px;
        color: #fff;
        border:1px solid #fff;
        font-size: 18px;
        border-radius: 5px;
        display: inline-block;
        z-index: 999;
        span{
            display: inline-block;
        }
        .btn-left{
            padding: 10px;
        }
        .btn-right{
            background-color: #002693;
            padding: 10px 20px;
            border-radius: 4px;
        }
    }
    h1{
        color: #fff;;
    }
    .bg-img{
        position: absolute;
        // top: 0;
        // bottom: 0;
        // left: 0;
        // right: 0;
        z-index: 1;
    }
}
</style>
